var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-start rounded border px-4 py-3 text-sm",class:_vm.toneClass},[_c('BaseIcon',{staticClass:"mt-0.5 mr-3 flex-shrink-0",class:_vm.iconClass,attrs:{"icon":_vm.icon || _vm.defaultIcon}}),_c('div',{staticClass:"leading-relaxed"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }